import NormalizedMissionHistoryPanel from 'components/NormalizedMissionHistoryPanel/NormalizedMissionHistoryPanel'
import type { NormalizedStatisticsApiRow } from 'features/tasksNormalized/filterableRecord'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectRobot } from 'store/selectors/robot'
import { GAUSIUM_ENABLED } from 'utils/constants'
import { VENDOR } from 'utils/vendorDisplayName'

import style from './RobotHistory.module.css'

type RobotHistoryProps = {
  onRowClick?: (row: NormalizedStatisticsApiRow) => void
  displayOffsetMinutes?: number
}

/** Mission execution history (normalized statistics) for the current robot. */
const RobotHistory = ({ onRowClick, displayOffsetMinutes }: RobotHistoryProps) => {
  const robot = useSelector(selectRobot)
  const sn = String(robot.robotInfo?.serialNumber || '').trim()
  const isGausium = robot.robotInfo?.vendor === VENDOR.GAUSIUM

  return (
    <div className={style.root}>
      <div className={style.tableWrapper}>
        <NormalizedMissionHistoryPanel
          robotSerialNumbers={sn ? [sn] : []}
          showStatusColumn={!isGausium}
          linkScenarioMissionToPages={isGausium}
          showGausiumReportActions={GAUSIUM_ENABLED && isGausium}
          onRowClick={onRowClick}
          displayOffsetMinutes={displayOffsetMinutes}
        />
      </div>
    </div>
  )
}

export default RobotHistory
